const EMPTY_CONFIG = {
  users: {},
  serviceApiKeys: {
    tms: '',
  },
};

const DEV_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const PROD_SERVICE_ENDPOINTS = {
  smsTicketUrl: 'https://api.h2sms.bte-inc.co.kr/autologin/ticket',
  smsWebUrl: 'https://h2sms.bte-inc.co.kr',
  tmsTicketUrl: 'https://api.h2tms.bte-inc.co.kr/bo/autologin/ticket',
  tmsWebUrl: 'https://h2tms.bte-inc.co.kr',
};

const DEV_SERVICE_ENDPOINTS = {
  smsTicketUrl: 'https://h2sms.dev.bte-inc.co.kr/api/autologin/ticket',
  smsWebUrl: 'https://h2sms.dev.bte-inc.co.kr',
  tmsTicketUrl: 'https://h2tms.dev.bte-inc.co.kr/api/bo/autologin/ticket',
  tmsWebUrl: 'https://h2tms.dev.bte-inc.co.kr',
};

const getRuntimeConfig = () => {
  if (typeof window === 'undefined') {
    return EMPTY_CONFIG;
  }

  return window.__IMS_RUNTIME_CONFIG__ || EMPTY_CONFIG;
};

export const getRuntimeUsers = () => getRuntimeConfig().users || {};

export const getRuntimeServiceApiKeys = () => getRuntimeConfig().serviceApiKeys || EMPTY_CONFIG.serviceApiKeys;

export const resolveDefaultServiceEndpoints = (hostname = '') => {
  const normalizedHostname = hostname.toLowerCase();
  const isDevHost = DEV_HOSTS.has(normalizedHostname) || normalizedHostname.endsWith('.dev.bte-inc.co.kr');

  return isDevHost ? DEV_SERVICE_ENDPOINTS : PROD_SERVICE_ENDPOINTS;
};

export const getRuntimeServiceEndpoints = () => {
  const runtimeConfig = getRuntimeConfig();
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  const runtimeServiceEndpoints = Object.fromEntries(
    Object.entries(runtimeConfig.serviceEndpoints || {}).filter(([, value]) => (
      typeof value === 'string' && value.trim() !== ''
    ))
  );

  return {
    ...resolveDefaultServiceEndpoints(hostname),
    ...runtimeServiceEndpoints,
  };
};

export default getRuntimeConfig;
